import immutable from 'immutable'
import { FLEETINFO } from '../actiontype'
const defaultState = immutable.fromJS({
    //邀请链接
    fleetQrCodeUrl : '',
    fleetManagerName : '',
    fleetManagerPhone : ''
})

export const fleetinfoReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETINFO:
            return state.updateIn(['fleetQrCodeUrl'], _ => (action.data.fleetQrCodeUrl))
                        .updateIn(['fleetManagerName'], _ => (action.data.fleetManagerName))
                        .updateIn(['fleetManagerPhone'],_ => (action.data.fleetManagerPhone))
        default:
            break;
    }
    return state
}
